import { Injectable } from '@angular/core';
import { Transaction } from 'ngx-mat-esign360/lib/transaction/model/transaction.model';

@Injectable()
export abstract class DtoParserService {
  constructor() {}

  abstract parseTransaction(dtoTransaction: any): Transaction;
}
